import { Category, CategoryWithChildren, CategoryUsage, CreateCategoryRequest, UpdateCategoryRequest } from '../types';

// Use relative URLs to go through React proxy instead of direct API calls
const API_BASE_URL = '/api';

export class CategoryService {
  async getAllCategories(): Promise<CategoryWithChildren[]> {
    const response = await fetch(`${API_BASE_URL}/categories`, { cache: 'no-store' });
    if (!response.ok) {
      throw new Error('Failed to fetch categories');
    }
    const result = await response.json();
    return result.data;
  }

  async getCategoriesByType(type: string): Promise<Category[]> {
    const response = await fetch(`${API_BASE_URL}/categories/${type}`, { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(`Failed to fetch ${type} categories`);
    }
    const result = await response.json();
    return result.data;
  }

  async createCategory(categoryData: CreateCategoryRequest): Promise<Category> {
    const response = await fetch(`${API_BASE_URL}/categories`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(categoryData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to create category');
    }

    const result = await response.json();
    return result.data;
  }

  async updateCategory(id: number, updateData: UpdateCategoryRequest): Promise<Category> {
    const response = await fetch(`${API_BASE_URL}/categories/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to update category');
    }

    const result = await response.json();
    return result.data;
  }

  async deleteCategory(id: number): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/categories/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to delete category');
    }
  }

  async getCategoryUsage(id: number): Promise<CategoryUsage> {
    const response = await fetch(`${API_BASE_URL}/categories/${id}/usage`);
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to get category usage');
    }
    const result = await response.json();
    return result.data;
  }
}

export const categoryService = new CategoryService();


